import { cva, type VariantProps } from 'class-variance-authority';

export const spinnerVariants = cva('inline-block shrink-0 relative', {
  variants: {
    size: {
      sm: 'size-5 [--bar-width:2px]',
      md: 'size-8 [--bar-width:2.5px]',
      lg: 'size-12 [--bar-width:3px]',
      xl: 'size-[50px] [--bar-width:3.5px]',
    },
    variant: {
      primary: 'text-ui-primary',
      accent: 'text-ui-primary-foreground',
      muted: 'text-ui-muted',
    },
  },
  defaultVariants: {
    size: 'md',
    variant: 'primary',
  },
});

export type SpinnerVariantProps = VariantProps<typeof spinnerVariants>;
